import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addFeatureFlag: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.add-feature-flag',
		defaultMessage: 'Add flag',
		description: 'Text for button used to add or connect feature flags to an issue.',
	},
	createFeatureFlagMenuItem: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.create-feature-flag-menu-item',
		defaultMessage: 'Create feature flag',
		description: 'Text for menu item to create feature flag.',
	},
	connectFeatureFlagMenuItem: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.connect-feature-flag-menu-item',
		defaultMessage: 'Connect feature flag',
		description: 'Text for menu item to connect feature flag.',
	},
	installAnotherToolMenuItem: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.add-feature-flag.install-another-tool-menu-item',
		defaultMessage: 'Install another tool',
		description: 'Text for menu item to install another provider.',
	},
});
